// src/utils/cryptoHelper.js

/**
 * Convertit une chaîne Hexadécimale en Uint8Array
 */
export function hexToBytes(hex) {
    if (hex.length % 2 !== 0) throw new Error("La chaîne hexadécimale doit avoir une longueur paire.");
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
        bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    }
    return bytes;
}

/**
 * Déchiffre des données en AES-CBC
 */
export async function decryptAesCbc(keyBytes, ivBytes, ciphertext) {
    const algo = { name: "AES-CBC", iv: ivBytes };
    const key = await window.crypto.subtle.importKey("raw", keyBytes, algo, false, ["decrypt"]);
    const decrypted = await window.crypto.subtle.decrypt(algo, key, ciphertext);
    return new TextDecoder().decode(decrypted);
}

/** Déchiffre les nouvelles données AES-GCM (nonce 12 octets, tag inclus). */
export async function decryptAesGcm(keyBytes, nonceBytes, ciphertextWithTag) {
    const algo = { name: "AES-GCM", iv: nonceBytes, tagLength: 128 };
    const key = await window.crypto.subtle.importKey("raw", keyBytes, algo, false, ["decrypt"]);
    const decrypted = await window.crypto.subtle.decrypt(algo, key, ciphertextWithTag);
    return new TextDecoder().decode(decrypted);
}

const GCM_MAGIC = [0x47, 0x43, 0x4d, 0x31]; // "GCM1"

function isGcmPayload(bytes) {
    return bytes.length >= 32 && GCM_MAGIC.every((byte, index) => bytes[index] === byte);
}

/**
 * Fonction principale de déchiffrement appelée par le Hook
 * NOTE : On ajoute 'key' en paramètre car on n'a plus accès à la Ref ici
 */
export async function decryptEventValue(encHex, key) {
    if (!key) {
        console.warn("[DECRYPT] ❌ Pas de clé disponible");
        return null;
    }

    try {
        // Les nouvelles sessions utilisent GCM1 + nonce(12) + ciphertext + tag(16).
        // Les sessions encore conservées au format IV(16) + CBC restent lisibles.
        const combined = hexToBytes(encHex);
        if (isGcmPayload(combined)) {
            const nonce = combined.slice(4, 16);
            const ciphertextWithTag = combined.slice(16);
            return decryptAesGcm(key, nonce, ciphertextWithTag);
        }

        const iv = combined.slice(0, 16);
        const ciphertext = combined.slice(16);
        return decryptAesCbc(key, iv, ciphertext);
    } catch (e) {
        console.error(`[DECRYPT] ❌ Échec:`, e.message);
        return null;
    }
}
